/**
 * ## Time selector component
 *
 * @module src/components/time
 */

"use strict";

const conf = require("../../config");
const availability = require("../../common").availability;
const moment = require("moment-timezone");
const l = require("../../common").localization;

/**
 * Time display.
 */
const create = (options, data, callback) => {
  let time24 = l.translate("h:mm a");
  if (options.hasOwnProperty("location") && options.location.time24) {
    time24 = "H:mm";
  }
  let d;
  let hour;
  if (isNaN(options.start) || options.start === "Select") {
    hour = 18;
  } else {
    hour = Math.floor(options.start / 4);
  }

  let avail = null;
  if (options.availability) {
    avail = availability.byDate(data.kd, options.date);
  }

  let thisHTML = '<div id="time_shell">';
  for (let i = 0; i < conf.vars.time.length; ++i) {
    let level = "";
    if (avail) {
      if (avail.slots[i].available) {
        const split =
          100 - Math.ceil((avail.slots[i].filled / avail.slots[i].seats) * 100);
        level = `style="background: rgba(19,19,19,1); \
                    background: linear-gradient(to bottom, rgba(39,39,39,1) 0%, rgba(35,35,35,1) \
                    ${split}%, rgba(76,76,76,1) ${split}%, rgba(76,76,76,1) 100%);"`;
      } else {
        level = 'style="background: rgb(0,0,0); color: #444;"';
      }
    }
    thisHTML += `<div class="time_select" ${level} \
                    id="time${i}" data-time="${conf.vars.time[i]}" \
                    data-index="${i}">${moment(
      conf.vars.time[i],
      "H:mma"
    ).format(time24)}</div>`;
  }
  thisHTML += "</div>";
  $(`#${options.target_id}`).html(thisHTML);
  setTimeout(() => {
    $("#component_catch").css("display", "block");
    const thisScroll = hour * 50;
    TweenMax.to($("#time_shell"), conf.vars.interfaceSpeed, {
      scrollTo: thisScroll,
      ease: Power2.easeOut,
    });
  }, 1);
  $(".time_select").off();
  $(".time_select").fastClick((e) => {
    destroy();
    let available = true;
    if (options.availability) {
      available = availability.check(
        data.kd,
        options.date,
        $(`#${e.target.id}`).data("index"),
        $("#modal_addparty_partysize").val()
      );
    }
    e.stopPropagation();
    const returned = {
      time: $(`#${e.target.id}`).data("time"),
      index: $(`#${e.target.id}`).data("index"),
      available,
    };
    callback(null, returned);
    $(".time_select").css("background", "#444");
    $(`#${e.target.id}`).css("background", "#aaa");
  });
};

const destroy = () => {
  $("#component_catch").css("display", "none");
};

module.exports = {
  create,
  destroy,
};



/** WEBPACK FOOTER **
 ** ./src/components/time/index.js
 **/